import { ClassificationLabels } from "./classification.map";

export const ClassificationStyles = {
    URGENCE_CHRONIQUE: {
        bg: "#fef3c7",
        color: "#92400e",
        border: "#f59e0b",
    },
    URGENCE_CHRONIQUE_AJOUT_TTT: {
        bg: "#ffedd5",
        color: "#c2410c",
        border: "#fb923c",
    },
    URGENCE_CHRONIQUE_MODIF: {
        bg: "#fed7aa",
        color: "#b45309",
        border: "#f97316",
    },
    URGENCE_CHRONIQUE_DOSAGE: {
        bg: "#fef9c3",
        color: "#854d0e",
        border: "#eab308",
    },
    URGENCE_CHRONIQUE_MODIF_POSOLOGIE: {
        bg: "#ecfccb",
        color: "#4d7c0f",
        border: "#84cc16",
    },
    DEPART_DC: {
        bg: "#e5e7eb",
        color: "#374151",
        border: "#9ca3af",
    },
    DEPART_SIMPLE: {
        bg: "#d1d5db",
        color: "#334155",
        border: "#64748b",
    },
    DEPART_HOSPITALISATION: {
        bg: "#f3e8ff",
        color: "#7e22ce",
        border: "#c084fc",
    },
    DEPART_VACANCES: {
        bg: "#fef2f2",
        color: "#991b1b",
        border: "#fca5a5",
    },
    NOUVEL_ENTRANT: {
        bg: "#dbeafe",
        color: "#1d4ed8",
        border: "#60a5fa",
    },
    URGENCE_AIGUE: {
        bg: "#cffafe",
        color: "#0e7490",
        border: "#06b6d4",
    },
    CNO_ORTHO_CONTENTION: {
        bg: "#ccfbf1",
        color: "#0f766e",
        border: "#14b8a6",
    },
    STUP: {
        bg: "#ede9fe",
        color: "#6d28d9",
        border: "#8b5cf6",
    },
    INFO_ADMIN: {
        bg: "#e0f2fe",
        color: "#0369a1",
        border: "#38bdf8",
    },
    RENOUVELLEMENT: {
        bg: "#f0fdf4",
        color: "#166534",
        border: "#4ade80",
    },
    PAS_DE_MODIF_NOUVELLE_ORDO: {
        bg: "#ecfeff",
        color: "#155e75",
        border: "#22d3ee",
    },
    PRIMO_MISE_EN_ATTENTE: {
        bg: "#fce7f3",
        color: "#be185d",
        border: "#f472b6",
    },
    LISTE_HP: {
        bg: "#dcfce7",
        color: "#15803d",
        border: "#22c55e",
    },
    RAS_ANCIENNE_ORDO: {
        bg: "#f1f5f9",
        color: "#475569",
        border: "#94a3b8",
    },
    RAS_NOUVELLE_ORDO: {
        bg: "#e0e7ff",
        color: "#4338ca",
        border: "#818cf8",
    },
    DEMANDE_EHPAD: {
        bg: "#fae8ff",
        color: "#a21caf",
        border: "#d946ef",
    },
};

export function classificationStyle(value) {
    return ClassificationStyles[value] || {
        bg: "#f1f5f9",
        color: "#475569",
        border: "#cbd5e1",
    };
}

export function classificationLabel(value) {
    return ClassificationLabels[value] || value;
}
